import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

import { CertificateButton } from '../CertificateButton';
import { CertificateStatusBlock } from '../CertificateStatusBlock';
import { DocumentDownloadButtons } from '../DocumentDownloadButtons';

import * as styles from './styles.module.css';

import type { Bundle, Coverage } from '../../types/Policy';
import type { InsifyProps } from '@insify/ui';

export const CoverageGridCard: React.FC<InsifyProps & { coverage: Coverage; policy: Bundle }> = ({
  className,
  coverage,
  policy,
}) => {
  const { t } = useTranslation('policy');

  // RiskCarrier is missing if the policy was not patched yet.
  const waitingCertificate = coverage.riskCarrier === undefined;

  return (
    <div data-hj-suppress id={coverage.title} className={styles.container}>
      <div key={coverage.wordingsURL} className={clsx(styles.coverageCard, className)}>
        <h4 className={styles.coverageTitle}>{t(coverage.title)}</h4>
        <div className={styles.infoContainer}>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>{t('policy_status')}</span>
            <span className={styles.infoField}>
              <CertificateStatusBlock
                coverage={coverage}
                waitingCertificate={waitingCertificate}
                className={styles.statusBlock}
              />
            </span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>{t('policy_id')}</span>
            <span className={styles.infoField}>{coverage.policyNumber}</span>
          </div>
          <div className={styles.infoRow}>
            <span className={styles.infoLabel}>{t('policy_start_date')}</span>
            <span className={styles.infoField}>{coverage.startDate}</span>
          </div>
        </div>

        {
          /* Currently only supporting FRANCE */
          coverage.title === 'coverage_professionalLiability' && <CertificateButton coverage={coverage} />
        }
        <div className={styles.actionButtons}>
          <DocumentDownloadButtons coverage={coverage} policyType={policy.type} />
        </div>
      </div>
    </div>
  );
};
